import { For, type JSX } from 'solid-js';
import { t } from '../../i18n';
import type { StartingRow } from '../../lib/send-work';
import { MoveTag } from './MoveTag';

// The jobs sent to this machine that it has not started yet (#6770, Sending step 6): each
// task's own title (deviation 3) with the accent "Starting" tag (`JOBTAG.starting`, `:1336`),
// until the machine claims it and it becomes the card's current job, or the 10-minute hard
// target sends it back to the open queue. Below the current job in Now; below the buttons on
// the simplified card. A task this page MOVED here is pending and targeted at this machine, so
// its "Moving" tag shows on this row (#6772, `MoveTag`).

export function StartingRows(props: { readonly rows: readonly StartingRow[] }): JSX.Element {
  return (
    <ul class="mission-starting">
      <For each={props.rows}>
        {(row) => (
          <li class="mission-starting__row" data-move-task={row.id}>
            <span class="mission-starting__title">{row.title}</span>
            <MoveTag taskId={row.id} />
            <span class="mission-card__tag mission-card__tag--live">
              {t('fleet.send.starting')}
            </span>
          </li>
        )}
      </For>
    </ul>
  );
}
